export enum StorageItemKeyEnum {
  ActiveProcessesIds = 'activeProcessesIds',
  otpRequestTimer = 'otpRequestTimer',
  brandingData = 'brandingData',
  FileOpened = 'fileOpened',
  AppUser = 'appUser',
  directOAuthProviders = 'directOAuthProviders',
}
